import React, { useRef, useState } from "react"

import * as S from "./styles"
import { useTranslation, useValidation } from "hooks"
import { translations } from "./translations"
import { Modal, Alert } from "components/shared"
import * as Yup from "yup"
import { Form } from "@unform/web"
import { FormHandles } from "@unform/core"
import { useMutation, useQuery } from "react-query"
import { Select } from "components/shared/Form"
import { apiGeneral, notify } from "services"

interface Props {
  clientId: string
}

const ClientCommercialTeam: React.FC<Props> = ({ clientId }) => {
  const [modalInfo, setModalInfo] = useState({ isOpen: false, id: null })
  const formCodeRef = useRef<FormHandles>(null)
  const { getTranslation } = useTranslation(translations)
  const { handleFormErrors } = useValidation()

  const { data, isLoading, refetch } = useQuery({
    queryKey: [`get-client-commercial-team-${clientId}`],
    queryFn: async () => {
      const { data } = await apiGeneral.get("/client-comercial-team?general_client_id=" + clientId)

      return data
    },
  })

  const { data: commercialTeam, isLoading: isLoadingCommercialTeam } = useQuery(
    {
      queryKey: [`get-commercial-team-${clientId}`],
      queryFn: async () => {
        const { data } = await apiGeneral.get("/comercial-team", {
          params: {
            role_id: 9,
            limit: 1000,
          },
        })

        return data
      },
      select: (data: any) => {
        return data?.data.map((d: any) => ({ label: d.name, value: d.id }))
      },
    }
  )

  // const {
  //   data: commercialContractType,
  //   isLoading: isLoadingCommercialContractType,
  // } = useQuery({
  //   queryKey: [`get-commercial-contract-${clientId}`],
  //   queryFn: async () => {
  //     const { data } = await apiGeneral.get("/commercial-contract-type")

  //     return data
  //   },
  //   select: (data: any) => {
  //     return data.map((d: any) => ({ label: d.name, value: d.id }))
  //   },
  // })

  const { mutate, isLoading: isPending } = useMutation({
    mutationFn: async (data: any) => {
      await apiGeneral.post("/client-comercial-team", {
        ...data,
        general_client_id: Number(clientId),
      })
    },
  })

  const handleSubmit = async (data: any) => {
    try {
      const schema = Yup.object().shape({
        commercial_team_id: Yup.string().required()
      })

      const dataFull = {
        ...data,
        commercial_contract_type_id: 1,
      }

      await schema.validate(dataFull, {
        abortEarly: false,
      })

      mutate(dataFull, {
        onSuccess: () => {
          formCodeRef.current?.clearField("commercial_team_id")
          // formCodeRef.current?.clearField("commercial_contract_type_id")
          refetch()
          notify("success", "Equipe comercial adicionar com sucesso!")
        },
        onError: (err) => {
          notify("error", "Oops! Não foi possível adicionar equipe comercial!")
        },
      })
    } catch (error) {
      handleFormErrors(error, formCodeRef)
    }
  }

  const { mutate: mutateDelete, isLoading: isPendingDelete } = useMutation({
    mutationFn: async (id: any) => {
      await apiGeneral.delete(`/client-comercial-team/${id}`)
    },
  })
  const handleDelete = () => {
    if (!modalInfo.id) return

    mutateDelete(modalInfo.id, {
      onSuccess: () => {
        refetch()
        setModalInfo({ isOpen: false, id: null })
        notify("success", "Equipe comercial removida com sucesso!")
      },
      onError: () => {
        notify("error", "Oops! Não foi possível remover equipe comercial.")
      },
    })
  }

  return (
    <S.Container>
      <Modal isOpen={modalInfo.isOpen}>
        <Alert
          title={`Remover Equipe Comercial`}
          text="Tem certeza que deseja realmente remover?"
          close={() => {
            setModalInfo({ isOpen: false, id: null })
          }}
          action={handleDelete}
          labelAction="Remover"
          isLoading={isPendingDelete}
        />
      </Modal>
      <S.Title>
        {getTranslation("timeComercial")} {isLoading && <S.Loading />}
      </S.Title>
      <S.Text>{getTranslation("descricao")}</S.Text>
      <S.BoxContainer>
        <Form
          ref={formCodeRef}
          onSubmit={handleSubmit}
          placeholder=""
          onPointerEnterCapture={() => { }}
          onPointerLeaveCapture={() => { }}
        >
          <S.FormRow>
            <Select
              name="commercial_team_id"
              label={getTranslation("commercialTeam")}
              isLoading={isLoadingCommercialTeam}
              isDisabled={isLoadingCommercialTeam}
              options={commercialTeam ?? []}
              placeholder={getTranslation("selecione")}
            />
            {/* <Select
              name="commercial_contract_type_id"
              label={getTranslation("commercialContractType")}
              isLoading={isLoadingCommercialContractType}
              isDisabled={isLoadingCommercialContractType}
              options={commercialContractType ?? []}
              placeholder={getTranslation("selecione")}
            /> */}
            <S.ButtonMini
              type="button"
              className="add"
              onClick={() => formCodeRef.current?.submitForm()}
            >
              {isPending ? <S.Loading /> : getTranslation("adicionar")}
            </S.ButtonMini>
          </S.FormRow>
        </Form>
        {data?.map((code: any) => (
          <S.Item key={code.id}>
            <S.ItemLabel>
              <span>{getTranslation("timeComercial")}: </span>
              {code.commercialTeam.name}
            </S.ItemLabel>
            <S.DeleteButton
              onClick={() => setModalInfo({ isOpen: true, id: code.id })}
              type="button"
            >
              <S.Trash size={22} />
            </S.DeleteButton>
          </S.Item>
        ))}
      </S.BoxContainer>
    </S.Container>
  )
}

export default ClientCommercialTeam
